import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Image from 'react-bootstrap/Image'
import { Fade } from 'react-reveal';

const ContentStyles = styled.div`
h2 {
  font-size: 22px;
}
h5 {
  color: #3A3A3A;
  font-size: 18px;
}
.telephone h5 {
  color: transparent;
}
.telephoneLink a {
  color: #212529
}
`;


class Contact extends Component {
  render() {
    return (
      <>
        <MetaTags>
          <title>Bize Ulaşın | Emlak Katılım Mortgage</title>
          <meta name="robots" content="all" />
          <meta name="description" content="Türkiye Emlak Katılım Bankası A.Ş. Emlak Katılım, 4603 Sayılı Kanun Kapsamında Kurulmuş Kamu Sermayeli Bir Katılım Bankasıdır." />
          <meta property="og:title" content="Bize Ulaşın | Emlak Katılım Mortgage" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://mortgage.emlakkatilim.com.tr/" />
          <meta property="og:image" content="/content/images/seo/emlak-logo-facebook-size.jpg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:description" content="Türkiye Emlak Katılım Bankası A.Ş. Emlak Katılım, 4603 Sayılı Kanun Kapsamında Kurulmuş Kamu Sermayeli Bir Katılım Bankasıdır." />
          <meta property="twitter:card" content="summary" />
          <meta property="twitter:site" content="@tremlakkatilim" />
          <meta property="twitter:title" content="Bize Ulaşın | Emlak Katılım Mortgage" />
          <meta property="twitter:url" content="https://mortgage.emlakkatilim.com.tr/" />
          <meta property="twitter:image" content="/content/images/seo/emlak-logo-twitter-size.jpg" />
          <meta property="twitter:description" content="Türkiye Emlak Katılım Bankası A.Ş. Emlak Katılım, 4603 Sayılı Kanun Kapsamında Kurulmuş Kamu Sermayeli Bir Katılım Bankasıdır." />
        </MetaTags>
        <ContentStyles>
          <Jumbotron className="subpageHeader" fluid>
            <Container>
              <Fade>
                <h1>Bize Ulaşın</h1>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                  <Breadcrumb.Item active>Bize Ulaşın</Breadcrumb.Item>
                </Breadcrumb>
              </Fade>
            </Container>
          </Jumbotron>
          <Container>
            <Row>
              <Col className="subpageContent">
                <Fade bottom cascade>
                  <section className="border-bottom mt-5 pb-4 mb-4">
                    <h2>Bize Ulaşın</h2>
                    <h5>Ticaret Ünvanı:</h5>
                    <p>Türkiye Emlak Katılım Bankası A.Ş.<br />Emlak Katılım, 4603 Sayılı Kanun Kapsamında Kurulmuş Kamu Sermayeli Bir Katılım Bankasıdır.</p>
                  </section>
                  <section className="border-bottom pt-2 pb-4 mb-4">
                    <Row>
                      <Col lg={4} xs={12}>
                        <h5>Mersis No:</h5>
                        <p>0879 0015 2770 0040</p>
                      </Col>
                      <Col lg={4} xs={12}>
                        <h5>Yer Sağlayıcı:</h5>
                        <p>Türkiye Emlak Katılım Bankası</p>
                      </Col>
                      <Col lg={4} xs={12}>
                        <h5>Denetim Mercii:</h5>
                        <p><a href="https://www.bddk.org.tr/" target="_blank" rel="noreferrer">Bankacılık Düzenleme ve Denetleme Kurumu</a></p>
                      </Col>
                    </Row>
                  </section>
                  <section className=" pt-2 pb-4 mb-4">
                    <Row>
                      <Col lg={4} xs={12}>
                        <h5>Adres:</h5>
                        <p>Barbaros Mahallesi, Begonya Sk. No:9A,<br />34746 Ataşehir/İstanbul</p>
                      </Col>
                      <Col lg={4} xs={12} className="telephone telephoneLink">
                        <h5>Telefon</h5>
                        <p>Telefon :<a href="tel:+902162662626">+90 (216) 266 26 26</a><br />Faks :<a href="tel:+902162752525">+90 (216) 275 25 25</a></p>
                      </Col>
                      <Col lg={4} xs={12} className="telephoneLink">
                        <h5>Çağrı Merkezi:</h5>
                        <p><a href="tel:+908502222626">0850 222 26 26</a> - <a href="tel:+904442626">444 26 26</a></p>
                      </Col>
                    </Row>
                  </section>
                  <section className=" pt-2 pb-4 mb-4">
                    <Row>
                      <Col><a href="https://g.page/EmlakKatilim?share" target="_blank" rel="noreferrer">
                        <Image className="mb-3" src="/content/images/emlak-google-map.jpg" alt="Emlak Katılım Google Maps" fluid />
                      </a>
                      </Col>
                    </Row>
                  </section>
                </Fade>
              </Col>
            </Row>
          </Container>
        </ContentStyles>
      </>
    );
  }
}

export default Contact;